import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "flex justify-between items-center px-2 py-2"
};
const _hoisted_3 = {
  class: "flex items-center space-x-2"
};
const _hoisted_4 = {
  key: 1,
  class: "transition-opacity duration-200 ease-in-out"
};
const _hoisted_5 = {
  key: 1,
  class: "transition-opacity duration-200 ease-in-out"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "w-full"
};
const _hoisted_8 = {
  class: "w-full"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "flex items-center justify-between sticky top-0 z-1 py-2"
};
const _hoisted_11 = {
  class: "flex-1"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1,
  class: "flex items-center justify-between p-1 sticky top-0 z-1 h-10"
};
import { storeToRefs } from 'pinia';
import MainHeader from '@/components/MainHeader.vue';
import Loader from '@/components/Loader.vue';
import { reactive, onMounted, computed, ref, onUnmounted, nextTick, watch, toRaw } from 'vue';
import TimekeeperPicker from '@/components/TimekeeperPicker.vue';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import DescriptionInput from '@/components/DescriptionInput.vue';
import CodePicker from '@/components/CodePicker.vue';
import BillableTypePicker from '@/components/BillableTypePicker.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import LlDoubleSwitch from '@/components/LlDoubleSwitch.vue';
import AlertBar from '@/components/AlertBar.vue';
import StartEndTime from './StartEndTime.vue';
import RateAdjustOptions from './RateAdjustOptions.vue';
import EntryActions from './EntryActions.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import InternalNotesToggle from '@/components/InternalNotesToggle.vue';
import CreateClient from '@/modules/clients/client/CreateClient.vue';
import CreateMatter from '@/modules/matters/CreateMatter.vue';
import CreateChargeModal from '@/modules/fixedfees/components/CreateChargeModal.vue';
import { round2 } from '@/services/utils';
import { useEntryStore } from '@/services/entryStore';
import { useEntryInitStore } from '@/services/useEntryInitStore';
import ListsService from '@/services/ListsService';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import { useRateGroupLogic } from '@/composables/useRateGroupLogic';
import { useBlockBilling } from '@/composables/useBlockBilling';
import { convertToHHSS, createDateFromLocalTime } from '@/services/utils.js';
import { useHoursValidation } from '@/composables/useHoursValidation';
// Import the time entry persistence composable
// This handles all form state saving/restoration during panel ↔ modal transitions
import { useTimeEntryFormStore } from '@/services/useTimeEntryFormStore';
import { useTimeEntryToggle } from '@/composables/useTimeEntryToggle';
import { useSnackbarStore } from '@/services/snackbarStore';
import { useTimeEntryShortcuts } from '@/composables/useTimeEntryShortcuts';
import { getShortcutTooltip } from '@/constants/keyboardShortcuts';
export default {
  __name: 'EditEntry',
  props: {
    state: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    snippetService: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    entryEditService: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    showExpandButton: {
      type: Boolean,
      default: false
    },
    showMinimizeButton: {
      type: Boolean,
      default: false
    },
    isTimeEntryPage: {
      type: Boolean,
      default: false
    },
    hideDuplicateButton: {
      type: Boolean,
      default: false
    },
    angularClientMatterManager: {
      type: Object,
      required: true
    }
  },
  emits: ['addOrEditEntry', 'close', 'expand', 'minimize'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const {
      params,
      stateParams
    } = props;

    // Extract and merge common values from params and stateParams
    // Extract and merge common values from params and stateParams with automatic reactivity
    const combinedParams = computed(() => ({
      entryId: params.entryId || stateParams.entryId,
      clientId: stateParams.clientId || params.clientId,
      matterId: stateParams.matterId || params.matterId,
      isBulkCreate: params.isBulkCreate || stateParams.isBulkCreate,
      internalNotes: params.internalNotes || stateParams.internalNotes,
      isNewEntry: params.isNewEntry,
      timerId: stateParams.timerId,
      entry: stateParams.entry || {},
      item: stateParams.item,
      adjustments: stateParams.adjustments,
      externalEvent: params.externalEvent,
      duplicateEntryId: params.duplicateEntryId
    }));
    const listsService = new ListsService();
    const entryBillingTypes = JSON.parse(JSON.stringify(listsService.entryBillingTypes));
    const entryStore = useEntryStore();
    const entryInitStore = useEntryInitStore();
    const {
      listAccounts
    } = useAccountsStore();
    const {
      getMatterByIdForEntryDropdown
    } = useClientMatterStore();
    const {
      getRateListWithSelection
    } = useRateGroupLogic();
    const {
      setOriginalValues
    } = useBlockBilling();
    const {
      getMe
    } = useMeStore();
    const {
      loadMyCompany
    } = useCompanyStore();
    const {
      features,
      me,
      permissions
    } = storeToRefs(useMeStore());
    const {
      companySettings,
      customFlagLabel
    } = storeToRefs(useCompanyStore());
    const {
      listChargesForTimeEntry
    } = useChargesStore();

    // Initialize persistence system for panel ↔ modal transitions
    // This prevents data loss when users switch between slide panel and full modal views
    const timeEntryFormStore = useTimeEntryFormStore();
    const snackbarStore = useSnackbarStore();
    const timeEntryToggle = useTimeEntryToggle();
    const emit = __emit;
    const editEntryState = reactive({
      accounts: [],
      matters: [],
      clients: [],
      advancedState: 'Standard',
      lockCalculatingHoursFromDescription: false,
      isUserChanging: false,
      // Flag to prevent rate conflicts during user/timekeeper changes
      rateList: [],
      duplicate: false,
      showKeepTimer: false,
      adjustments: false,
      matterLoading: false,
      showStartStopTime: false,
      isTimerConversion: false,
      masks: {
        input: 'MM-DD-YYYY'
      },
      form: {
        client: {},
        matter: {},
        codes: {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        }
      },
      // onMounted starts loading at once; starting false renders a throwaway form that is then torn down.
      loading: true,
      formRestorationInProgress: false,
      // Flag to track form restoration state - prevents interference during persistence restoration
      entryBillingTypes: [],
      duplicate: false,
      // Flag indicating this is a duplicate entry (affects session management)
      originalEntry: null,
      // Snapshot of original form state for change detection
      isInitialEditEntryLoad: false,
      // Flag for first-time loading logic
      matterChangedDuringSession: false,
      // Flag to track if user has changed matters during editing session
      matterDetail: null
    });
    const clientMatterSearchRef = ref(null);
    const deleteConfirmRef = ref(null);
    const unsavedChangesConfirmRef = ref(null);
    const createClientRef = ref(null);
    const createMatterRef = ref(null);
    // Key to force re-render of ClientMatterSearch component when form state is restored
    // This ensures the search component displays the correct client/matter after transitions
    const clientMatterSearchKey = ref(0);
    const createChargeRef = ref(null);
    const descriptionInputKey = ref(0);
    const showCreateClient = ref(false);
    const showCreateMatter = ref(false);
    const showCreateCharge = ref(false);
    const unsavedDialog = reactive({
      title: 'Discard Changes?',
      message: 'You have unsaved changes to this time entry. If you close now, your edits will be lost.',
      confirmText: 'Discard Changes',
      toggleText: 'Keep Editing'
    });
    const rootElementRef = ref(null);
    const formValid = computed(() => {
      // CRITICAL: Skip validation during form restoration to prevent save button from being disabled
      // during panel ↔ modal transitions. The restoration process temporarily modifies form state
      // which can trigger false validation failures and disable the save button incorrectly.
      if (editEntryState.formRestorationInProgress) {
        return true;
      }
      const f = editEntryState.form;

      // Required fields validation
      if (!f.account?.id) {
        return false;
      }
      if (!f.date) {
        return false;
      }
      if (!f.matter?.id) {
        return false;
      }
      if (!f.description || f.description.trim() === '') {
        return false;
      }
      const {
        isHoursValid
      } = useHoursValidation(f);
      if (!isHoursValid.value) {
        return false;
      }
      if (editEntryState.showStartStopTime) {
        const timeFormat = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
        if (!f.startTime || !f.endTime) {
          return false;
        }
        if (!timeFormat.test(f.startTime) || !timeFormat.test(f.endTime)) {
          return false;
        }
      }

      // Rate validation
      if (f.rate?.amount !== undefined && f.rate?.amount !== null && f.rate?.amount !== '') {
        const rateAmount = parseFloat(f.rate.amount);
        if (!isNaN(rateAmount) && rateAmount < 0) {
          return false;
        }
      }

      // Write-down validation if adjustments are enabled
      if (editEntryState.adjustments && companySettings.value.adjustments) {
        const hours = parseFloat(f.hours);
        const writedown = parseFloat(f.writedown || 0);
        if (writedown < 0) {
          return false;
        }
        if (writedown > hours) {
          return false;
        }
        const billedHours = hours - writedown;
        if (billedHours < 0) {
          return false;
        }
      }
      if (companySettings.value.codes?.ledes && editEntryState.matterDetail?.client?.codes?.ledes) {
        const requiredCodes = editEntryState.matterDetail?.client?.codes?.required || {};
        const createCodes = f?.codes || {};
        if (requiredCodes.activity && !createCodes.activity?.id) {
          return false;
        }
        if (requiredCodes.task && !createCodes.task?.id) {
          return false;
        }
      }
      return true;
    });
    const cmQueryFilter = computed(() => {
      const {
        autoAssign
      } = me.value?.permissions?.matters || {};
      return {
        scopeAccount: editEntryState.form.account ? editEntryState.form.account.id : null,
        originating: false,
        involved: editEntryState.form.account ? !autoAssign : false,
        reviewer: false,
        primary: false,
        archived: false
      };
    });
    const createChargeStateParams = computed(() => {
      return {
        clientId: editEntryState.form.client?.id,
        matterId: editEntryState.form.matter?.id,
        showClientMatter: false,
        fixedFeeTemplate: false,
        showAllocation: false
      };
    });
    const showCodePicker = computed(() => {
      // Show code picker when matter has LEDES codes and not loading
      return !!(editEntryState.matterDetail?.id && editEntryState.matterDetail?.client?.codes?.ledes && !editEntryState.loading && !editEntryState.matterLoading && !editEntryState.formRestorationInProgress);
    });
    const showBillableTypePicker = computed(() => {
      // Always show billable type picker when not in initial loading states
      return !editEntryState.loading && !editEntryState.matterLoading && !editEntryState.formRestorationInProgress;
    });
    const showCodePickerSkeleton = computed(() => {
      return !!(editEntryState.matterDetail?.id && editEntryState.matterLoading && !editEntryState.loading && !editEntryState.formRestorationInProgress);
    });
    const showBillableTypePickerSkeleton = computed(() => {
      // Show billable type picker skeleton only when loading matter data (not during form restoration)
      return editEntryState.matterLoading && !editEntryState.loading && !editEntryState.formRestorationInProgress;
    });
    const isFixedFeeSelected = computed(() => {
      return editEntryState.form.billingType?.id === 'fixedFee' || editEntryState.form.billingType === 'fixedFee';
    });
    const showRateAdjustment = computed(() => {
      // Always require a matter to be selected first
      if (!editEntryState.form.matter?.id) {
        return false;
      }

      // For new entries, only show when billable billing type is selected
      if (combinedParams.value.isNewEntry) {
        const billingType = editEntryState.form.billingType?.id || editEntryState.form.billingType;
        return billingType === 'billable';
      }
      // Show for existing entries
      return !editEntryState.loading && !editEntryState.matterLoading;
    });
    const localDefaultStep = computed(() => companySettings.value.timeEntryIncrement || 0.1);
    const headerContent = computed(() => {
      if (editEntryState.duplicate) {
        return 'Duplicate Time Entry';
      }
      if (combinedParams.value.entryId) {
        return 'Edit Time Entry';
      }
      return 'New Time Entry';
    });
    const isActivityRequired = computed(() => {
      const requiredCodes = editEntryState.matterDetail?.client?.codes?.required || {};
      return !!requiredCodes.activity;
    });
    const isTaskRequired = computed(() => {
      const requiredCodes = editEntryState.matterDetail?.client?.codes?.required || {};
      return !!requiredCodes.task;
    });

    // Determine when to enable autofocus - should focus for new entries (especially from shortcuts)
    const shouldAutofocus = computed(() => {
      // Enable autofocus for new entries (when opened via shortcut or create new button)
      // This includes entries without ID (truly new) or duplicate entries
      return editEntryState.form.id || editEntryState.duplicate || combinedParams.value.isNewEntry;
    });
    const isLoading = computed(() => {
      return !!(editEntryState.loading ||
      // CRITICAL: Don't treat form restoration as a loading state that disables buttons
      // This prevents the save button from being disabled during panel ↔ modal transitions
      editEntryState.matterLoading && !editEntryState.formRestorationInProgress || showCodePickerSkeleton.value || entryStore.saving);
    });

    // Computed property for container classes
    const containerClasses = computed(() => {
      if (props.isModal) {
        return ['overflow-y-auto', 'modal-container'];
      }
      return [];
    });

    // Computed property for timekeeper picker disabled state
    const isTimekeeperPickerDisabled = computed(() => {
      // If the entry is billed, always disable
      if (editEntryState.form.billed) {
        return true;
      }

      // Get permissions, with fallback handling
      const timePermissions = permissions.value.time || {};
      const hasCreateOthers = timePermissions.createOthers || false;

      // Enable if user has createOthers permission
      return !hasCreateOthers;
    });

    // Store reference to auto-save cleanup function from the persistence system
    let stopAutoSave = null;

    // Set up lifecycle hooks (must be called synchronously during setup)
    onUnmounted(() => {
      // Clean up auto-save watcher to prevent memory leaks
      if (stopAutoSave) stopAutoSave();
      // Clean up keyboard shortcuts
      if (shortcuts) {
        shortcuts.removeKeyboardListener();
        shortcuts = null;
      }
      // Event listener cleanup
      rootElementRef.value?.removeEventListener('duplicate-entry', handleExternalDuplicateRequest);
    });

    // Computed property to determine if we should show the billed alert
    const shouldShowBilledAlert = computed(() => {
      const form = editEntryState.form;
      if (form?.billedState && form.billedState !== 'WIP') {
        return true;
      }

      // Show alert if entry is manually marked as billed
      if (form?.billed) {
        return true;
      }
      return false;
    });
    const getBilledAlertMessage = () => {
      const form = editEntryState.form;

      // Handle manually marked as billed entries (most specific)
      if (form?.billed) {
        // Check if it's system-billed (has invoice.id) or manually marked
        if (form.invoice?.id) {
          return 'This time entry was billed and cannot be changed.';
        } else {
          return 'This time entry has been marked as billed and cannot be changed unless unmarked.';
        }
      }
      if (form?.billedState === 'Interim') {
        return 'This entry is currently in a draft invoice. It can only be edited within the draft.';
      }
      if (form?.billedState && form.billedState !== 'WIP') {
        return 'This time entry was billed and cannot be changed.';
      }
      return '';
    };
    onMounted(async () => {
      // Add updateEndTime method fallback if not provided
      // This handles cases where entryEditService might not be fully initialized
      if (props.entryEditService && !props.entryEditService.updateEndTime) {
        props.entryEditService.updateEndTime = form => {
          try {
            // Calculate end time based on start time and hours
            if (form && form.startTime && form.hours) {
              const start = new Date(form.startTime);
              const hoursToAdd = parseFloat(form.hours) || 0;
              const endTime = new Date(start.getTime() + hoursToAdd * 60 * 60 * 1000);
              form.endTime = endTime;
            }
          } catch (error) {
            console.error('Error in updateEndTime fallback:', error);
          }
        };
      }
      editEntryState.loading = true;
      const basePromises = [getMe(), loadMyCompany(), listAccounts()];
      const [_, __, accounts] = await Promise.allSettled(basePromises).then(results => results.map(r => r.status === 'fulfilled' ? r.value : null));
      if (accounts) editEntryState.accounts = accounts;
      entryInitStore.updateStep(localDefaultStep.value);
      if (combinedParams.value.duplicateEntryId) {
        await duplicateEntry(combinedParams.value.duplicateEntryId);

        // Initialize persistence for duplicated entries
        // This ensures form state can be saved/restored during panel ↔ modal transitions
        await timeEntryToggle.initializePersistence(editEntryState, combinedParams.value, setFormState);
        return;
      } else if (combinedParams.value.entryId) {
        const entry = await entryStore.getEntry(combinedParams.value.entryId);
        if (!entry || !entry.id) {
          return;
        }
        const loadedEntry = entryInitStore.loadEntry(entry);
        const {
          id
        } = entry.account;
        const user = editEntryState.accounts.find(u => u.id === id);

        // Filter only valid accounts, skipping the 'accountant' role accounts.
        editEntryState.accounts = editEntryState.accounts.filter(u => u.role !== 'accountant');

        // If the entry's account is not in the list (e.g. deactivated user or accountant role),
        // add them back so the timekeeper dropdown displays correctly for existing entries.
        if (!editEntryState.accounts.find(a => a.id === id)) {
          editEntryState.accounts.push(user || entry.account);
        }
        editEntryState.isInitialEditEntryLoad = true;
        await processEntry(loadedEntry);

        // Initialize billing types and trigger matterChanged for existing entries
        // This ensures the BillableTypePicker has the correct options available
        editEntryState.entryBillingTypes = entryBillingTypes;
        if (editEntryState.form.matter?.id) {
          await matterChanged();
        }
      } else {
        const {
          clientId,
          matterId,
          entry,
          item
        } = combinedParams.value;
        const newEntry = {
          ...entry
        };
        if (clientId) {
          newEntry.client = {
            id: clientId
          };
        }
        if (matterId) {
          newEntry.matter = {
            id: matterId
          };
        }
        const newDefaultEntry = entryInitStore.newDefaultEntry(newEntry, item);

        // Set default hours to the company's time entry increment for new entries
        if (!newDefaultEntry.hours || newDefaultEntry.hours === 0) {
          newDefaultEntry.hours = localDefaultStep.value;
        }
        editEntryState.accounts = editEntryState.accounts.filter(user => user.role !== 'accountant');

        // Initialize billing types for new entries
        editEntryState.entryBillingTypes = entryBillingTypes;
        await processEntry(newDefaultEntry);

        // Initialize billing types and trigger matterChanged for new entries with pre-selected matter
        // This ensures the matter details and user rates are loaded via API call
        if (newDefaultEntry.matter?.id) {
          await matterChanged();
        }
      }
      if (combinedParams.value.externalEvent) {
        const loadedEntry = entryInitStore.loadEntryFromExternalEvents(combinedParams.value.externalEvent);

        // Set default hours to the company's time entry increment for external events if not set
        if (!loadedEntry.hours || loadedEntry.hours === 0) {
          loadedEntry.hours = localDefaultStep.value;
        }

        // Initialize billing types for external events
        editEntryState.entryBillingTypes = entryBillingTypes;
        await processEntry(loadedEntry);

        // Initialize billing types and trigger matterChanged for external events with matter
        // This ensures the matter details and user rates are loaded via API call
        if (loadedEntry.matter?.id) {
          await matterChanged();
        }
      }
      editEntryState.showKeepTimer = !!combinedParams.value.timerId;
      editEntryState.isTimerConversion = !!combinedParams.value.timerId;
      editEntryState.isBulkCreate = combinedParams.value.isBulkCreate;
      editEntryState.entryId = combinedParams.value.entryId;

      // CRITICAL: Clear any persisted form state if this is explicitly a new entry
      // This prevents old entry data from appearing when clicking "Create New Entry"
      if (combinedParams.value.clearPersistedState) {
        timeEntryFormStore.clearFormState();
      }

      // CRITICAL: For timer conversions, always clear persisted state to ensure
      // timer's client/matter data takes precedence over any cached form data
      if (editEntryState.isTimerConversion) {
        timeEntryFormStore.clearFormState();
      } else {
        // Initialize simple persistence: restore saved state if it exists
        // Only do this for non-timer entries to avoid overriding timer data
        await timeEntryToggle.initializePersistence(editEntryState, combinedParams.value, setFormState);
      }

      // Complete the component setup
      // CRITICAL: Only set original form if we don't already have one from restored state
      // This preserves the change detection baseline during panel ↔ modal transitions
      if (!editEntryState.originalEntry) {
        setOriginalForm();
      }

      // Store original values when component mounts using the composable
      if (editEntryState.form) {
        setOriginalValues(editEntryState.form.description || '', editEntryState.form.hours || 0);
      }
      editEntryState.loading = false;
      // Typing pause detection logic for preventing shortcuts during active typing
      let lastTypedAt = 0;
      const TYPING_PAUSE_THRESHOLD = 250; // 250ms as specified in requirements

      // Check if user is actively typing (to suppress shortcuts)
      const isActivelyTyping = () => {
        const activeElement = document.activeElement;
        const isInInput = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');
        const recentlyTyped = Date.now() - lastTypedAt < TYPING_PAUSE_THRESHOLD;
        const result = isInInput && recentlyTyped;
        return result;
      };

      // Add event listener for external duplicate requests
      onMounted(() => {
        if (rootElementRef.value) {
          rootElementRef.value.addEventListener('duplicate-entry', handleExternalDuplicateRequest);
        }
      });

      // Cleanup event listeners
      onUnmounted(() => {
        if (rootElementRef.value) {
          rootElementRef.value.removeEventListener('duplicate-entry', handleExternalDuplicateRequest);
        }
      });

      // Shortcuts are now managed by watcher
    }); // Close the onMounted function

    const processEntry = async entry => {
      editEntryState.form = entry;
      editEntryState.okToClearDescription = !entry.description;
      // Use entry.date for the date field, not entry.startTime (which may be a Date object or HH:mm string)
      editEntryState.date = entry.date instanceof Date ? entry.date : new Date(entry.date);
      editEntryState.form.account = getAccountById();
      editEntryState.form.note = entry.note || '';

      // Call updateEndTime BEFORE converting to strings (it expects Date objects)
      // Ensure startTime is a Date object before calling updateEndTime
      if (props.entryEditService?.updateEndTime) {
        // If startTime is a string (e.g., "10:30" from restored state), convert to Date first using date-fns
        // createDateFromLocalTime handles validation internally and returns null for invalid inputs
        if (editEntryState.form.startTime && !(editEntryState.form.startTime instanceof Date)) {
          const startDate = createDateFromLocalTime(editEntryState.date, editEntryState.form.startTime);
          if (startDate) {
            editEntryState.form.startTime = startDate;
          }
        }
        props.entryEditService.updateEndTime(editEntryState.form);
      }

      // Convert Date objects to HH:mm strings for time inputs
      // Story #41530: loadEntry now returns Date objects for startTime/endTime
      if (entry.startTime instanceof Date) {
        editEntryState.form.startTime = convertToHHSS(entry.startTime);
      }
      if (entry.endTime instanceof Date) {
        editEntryState.form.endTime = convertToHHSS(entry.endTime);
      }

      // Normalize billing type to ensure it's always an object with id and label
      // API might return just a string like "nonBillable" instead of {id: "nonBillable", label: "Non-Billable"}
      if (entry.billingType && typeof entry.billingType === 'string') {
        const billingTypeId = entry.billingType;
        const billingTypeObj = entryBillingTypes.find(bt => bt.id === billingTypeId);
        if (billingTypeObj) {
          editEntryState.form.billingType = billingTypeObj;
        } else {
          // Fallback for unknown billing types
          editEntryState.form.billingType = {
            id: billingTypeId,
            label: billingTypeId
          };
        }
      }
      if (companySettings.value.adjustments && entry.billedHours !== undefined) {
        const billedHours = entry.billedHours || entry.hours;
        editEntryState.adjustments = combinedParams.value.adjustments || entry.hours > billedHours;
        if (editEntryState.adjustments) {
          editEntryState.form.writedown = round2(entry.hours - billedHours);
        }
      }
    };

    /**
     * Tracks the system-determined default rate signature in format 'label::amount' (e.g., "Standard Rate::250.00").
     * Reset when matter/user changes. Used to determine if user has edited rate away from default.
     */
    let defaultRateSignature = null;
    const adjustRateToSelection = async (isMatterChange = false, isUserChange = false) => {
      if (!editEntryState.matterDetail || !editEntryState.form.account) {
        editEntryState.rateList = [];
        return;
      }
      const isExistingEntry = !!editEntryState.form.id && !editEntryState.duplicate;
      const {
        rateList,
        selectedRate
      } = getRateListWithSelection(editEntryState.form.account, editEntryState.matterDetail, isExistingEntry, editEntryState.form, isMatterChange, isUserChange,
      // Pass the new parameter to the rate logic
      editEntryState.duplicate,
      // Pass the duplicate flag
      editEntryState.originalEntry,
      // Pass the original entry for matter change detection
      editEntryState.matterChangedDuringSession // Pass the session flag
      );
      editEntryState.rateList = rateList;
      if (selectedRate) {
        // CRITICAL: Preserve the 'edited' flag when updating rate from getRateListWithSelection
        // For existing entries with edited=true, ALWAYS keep it (sticky behavior)
        const isExistingEntry = !!editEntryState.form.id && !editEntryState.duplicate;
        const currentEditedFlag = editEntryState.form.rate?.edited === true;
        editEntryState.form.rate = selectedRate;
        // IMPORTANT: For existing entries, if edited flag was true, keep it permanently
        if (isExistingEntry && currentEditedFlag) {
          editEntryState.form.rate.edited = true;
        }
      }

      // Establish / refresh default rate signature when first determined or after matter/user changes.
      // CRITICAL: Only set baseline if rate is NOT already marked as edited
      // If rate.edited exists, the baseline was already set and this is a user-edited rate
      if (editEntryState.form.rate && (defaultRateSignature === null || isMatterChange || isUserChange)) {
        // Don't reset baseline if this rate is already marked as edited (from loaded entry)
        if (!editEntryState.form.rate.edited) {
          setDefaultRateBaseline(editEntryState.form.rate, true);
        }
      }
    };

    /**
     * Creates stable rate signature 'label::amount' for comparison. Normalizes amounts to 2 decimals.
     * Returns 'null' if rate is null, or 'label::null' if amount is null.
     */
    const buildRateIdentity = rate => {
      if (!rate) return 'null';
      const amount = rate.amount == null ? 'null' : Number(rate.amount).toFixed(2);
      return `${rate.label || ''}::${amount}`;
    };

    /**
     * Sets baseline rate signature. Preserves existing 'edited' flag from saved entries.
     */
    const setDefaultRateBaseline = (rate, force = false) => {
      if (!rate) return;
      if (force || defaultRateSignature === null) {
        const oldSignature = defaultRateSignature;
        // Never delete the edited flag - just establish the baseline signature
        // The edited flag should only be managed by handleRateChangeUpdate
        defaultRateSignature = buildRateIdentity(rate);
      }
    };
    const normalizeNumericValue = value => {
      if (value === null || value === undefined || value === '') {
        return 0;
      }
      const num = parseFloat(value);
      return isNaN(num) ? 0 : num;
    };
    const normalizeDateValue = dateValue => {
      if (!dateValue) {
        return null;
      }
      try {
        const d = new Date(dateValue);
        return typeof d.toNetworkDate === 'function' ? d.toNetworkDate() : d.toISOString().slice(0, 10);
      } catch {
        return null;
      }
    };
    const formatTime = time => {
      if (!time) return null;

      // If the value is already in HH:MM string format, use it directly
      if (typeof time === 'string' && /^\d{2}:\d{2}/.test(time)) {
        return time.slice(0, 5);
      }
      const date = new Date(time);
      if (!isNaN(date.getTime())) {
        return convertToHHSS(date);
      }
      return null;
    };
    const getSimplifiedForm = (entry, ignoreStartStop = false) => {
      const rateLabel = (entry.billingType?.id || entry.billingType) === 'billable' ? entry.rate?.label || null : null;
      const rateAmount = (entry.billingType?.id || entry.billingType) === 'billable' ? normalizeNumericValue(entry.rate?.amount) : null;
      return {
        accountId: entry.account?.id || null,
        matterId: entry.matter?.id || null,
        clientId: entry.client?.id || entry.matter?.client?.id || null,
        description: entry.description || '',
        note: entry.note || '',
        date: normalizeDateValue(entry.date),
        hours: normalizeNumericValue(entry.hours),
        writedown: normalizeNumericValue(entry.writedown),
        billedHours: normalizeNumericValue(entry.billedHours),
        billingType: entry.billingType?.id || entry.billingType || null,
        chargeId: entry.charge?.id || null,
        customFlag: entry.customFlag,
        activityId: entry.codes?.activity?.id || null,
        taskId: entry.codes?.task?.id || null,
        rateLabel: rateLabel,
        rateAmount: rateAmount,
        ...(ignoreStartStop ? {} : {
          startTime: formatTime(entry.startTime),
          endTime: formatTime(entry.endTime)
        })
      };
    };
    const setOriginalForm = () => {
      editEntryState.originalEntry = JSON.parse(JSON.stringify(editEntryState.form));
    };
    const createEntry = async (keepTimer = false, bulkEntry = false, trackingCallback = null) => {
      // Check form validity using the reactive formValid property
      if (!formValid.value) {
        // Different error handling for modal vs regular usage
        const errorMessage = props.isModal ? 'Please fill in all required fields before saving.' : 'Your form is not valid. Please check the fields and try again.';
        props.alerts?.error?.(errorMessage);
        return;
      }
      try {
        // This ensures we have the correct state for success messaging and UI updates
        const isNewEntry = !editEntryState.form.id || editEntryState.duplicate;
        let close = false;
        if (!editEntryState.matterDetail?.client?.codes?.ledes && companySettings.value.codes?.ledes) {
          editEntryState.form.codes = {};
        }
        if (editEntryState.adjustments) {
          editEntryState.form.billedHours = editEntryState.form.hours - editEntryState.form.writedown;
        } else {
          editEntryState.form.billedHours = editEntryState.form.hours;
        }

        // Duplicate entries should always create a new entry, regardless of form ID
        if (isNewEntry) {
          // For duplicate entries, ensure we remove any existing ID to force creation
          if (editEntryState.duplicate && editEntryState.form.id) {
            delete editEntryState.form.id;
          }
          const createResult = await entryStore.createEntry(editEntryState.form);
          close = createResult === true; // createEntry returns true on success, false on error
          trackM365TimeEntry(editEntryState.form);
        } else {
          const updateResult = await entryStore.updateEntry(editEntryState.form);
          close = updateResult !== false && updateResult !== undefined;
        }
        if (close && bulkEntry) {
          // Use captured isNewEntry state for better messaging
          const successMessage = isNewEntry ? props.isModal ? 'Time entry created successfully!' : 'Time entry successfully created.' : props.isModal ? 'Time entry updated successfully!' : 'Time entry successfully updated.';
          props.alerts?.success?.(successMessage);

          // Call tracking callback after successful save
          if (trackingCallback && typeof trackingCallback === 'function') {
            trackingCallback();
          }
          editEntryState.form.description = '';
          //  when we change the key prop on a Vue component (like incrementing descriptionInputKey), Vue treats it as a completely different component and:
          // Force component re-render to reset validation state
          // This is essentially a "nuclear reset" that forces the component to start fresh (Resets all internal state (validation, touched/dirty flags, etc.).
          descriptionInputKey.value += 1;

          // Clear persisted form state after successful save to prevent old data from appearing
          timeEntryToggle.handlePostSaveClearance(editEntryState, combinedParams);
          return;
        }
        if (close) {
          // Show success message for non-bulk entries using snackbar
          if (!bulkEntry) {
            const successMessage = isNewEntry ? 'Time entry created successfully!' : 'Time entry updated successfully!';
            snackbarStore.showSnackbar('success', successMessage);
          }

          // Call tracking callback after successful save
          if (trackingCallback && typeof trackingCallback === 'function') {
            try {
              trackingCallback();
            } catch (e) {
              console.error('[EditEntry] Error calling tracking callback:', e);
            }
          }

          // Use captured isNewEntry state for broadcast metadata
          if (props.rootScope?.$broadcast) {
            try {
              props.rootScope.$broadcast('planner-entry-saved', combinedParams.value.timerId, editEntryState.form, keepTimer, {
                isCreateOperation: isNewEntry
              } // Use captured state for accurate metadata
              );
            } catch (e) {
              console.error('[EditEntry] Error broadcasting planner-entry-saved:', e);
            }
          }

          // Clear persisted form state after successful save to prevent old data from appearing
          try {
            timeEntryToggle.handlePostSaveClearance(editEntryState, combinedParams.value);
          } catch (e) {
            console.error('[EditEntry] Error clearing form state:', e);
          }
          closeModal(true, isNewEntry);
        } else {
          const errorMessage = props.isModal ? 'Unable to save entry. Please check your connection and try again.' : 'Error saving entry. Please check your connection and try again.';
          props.alerts?.error?.(errorMessage);
        }
      } catch (error) {
        const errorMessage = props.isModal ? 'Unable to save entry. Please try again.' : 'Error saving entry. Please try again.';
        props.alerts?.error?.(errorMessage);
      }
    };

    // Initialize keyboard shortcuts for EditEntry modal using existing useExperimentalShortcuts parameter
    // Must be after createEntry is defined to ensure proper closure
    let trackTimeEntryAction = () => {}; // Default no-op function
    // Keyboard shortcuts management
    let shortcuts = null;
    const initializeShortcuts = () => {
      // Clean up existing shortcuts first
      if (shortcuts) {
        shortcuts.removeKeyboardListener();
        shortcuts = null;
      }

      // Only initialize if feature flag is enabled
      if (features.value?.enableTimeEntryShortcuts) {
        shortcuts = useTimeEntryShortcuts({
          onSave: trackingCallback => {
            setTimeout(() => {
              createEntry(false, false, trackingCallback);
            }, 10);
          },
          onSaveAndNew: trackingCallback => {
            createEntry(false, true, trackingCallback);
          },
          onCancel: () => {
            handleCloseClick();
          },
          isFormValid: () => formValid.value,
          isSaveAndNewAllowed: () => !editEntryState.entryId && !props.isModal,
          tracking: props.tracking,
          enableGlobalShortcuts: false
        });

        // Manually setup keyboard listener (avoid Vue lifecycle issues)
        shortcuts.setupKeyboardListener();
        trackTimeEntryAction = shortcuts.trackTimeEntryAction;
      }
    };

    // Watch for feature flag changes
    watch(() => features.value?.enableTimeEntryShortcuts, () => {
      initializeShortcuts();
    }, {
      immediate: true
    });
    const isEntryValid = () => {
      const f = editEntryState.form;
      if (!f.account?.id) return false;
      if (!f.matter?.id) return false;
      if (!f.description || f.description.trim() === '') return false;
      if (!f.hours || parseFloat(f.hours) <= 0) return false;
      if (f.rate?.amount < 0) return false;
      return true;
    };
    const confirmDiscardChanges = async (action = 'selecting a different one') => {
      // If still loading, nothing meaningful to save yet — proceed without saving
      if (editEntryState.loading) {
        return true;
      }
      if (!somethingChanged.value) {
        return true;
      }
      const hasId = !!editEntryState.form.id;
      const valid = isEntryValid();
      let message = '';
      let confirmText = '';
      let toggleText = '';
      let onConfirm;
      let proceedOnToggle = false;
      if (hasId) {
        if (valid) {
          message = `Would you like to save your changes to the selected entry before ${action}?`;
          confirmText = 'Save and Continue';
          toggleText = 'Keep Editing';
          onConfirm = async () => {
            await createEntry();
            return true;
          };
          proceedOnToggle = false;
        } else {
          message = `Would you like to finish editing the selected entry before ${action}?`;
          confirmText = 'Finish Editing';
          toggleText = 'Discard Changes';
          onConfirm = async () => false;
          proceedOnToggle = true;
        }
      } else {
        if (valid) {
          message = `Do you want to save your new entry before ${action}?`;
          confirmText = 'Save and Continue';
          toggleText = 'Keep Editing';
          onConfirm = async () => {
            await createEntry();
            return true;
          };
          proceedOnToggle = false;
        } else {
          message = `Would you like to keep editing your new entry before ${action}?`;
          confirmText = 'Keep Editing';
          toggleText = 'Discard Changes';
          onConfirm = async () => false;
          proceedOnToggle = true;
        }
      }
      unsavedDialog.title = '';
      unsavedDialog.message = message;
      unsavedDialog.confirmText = confirmText;
      unsavedDialog.toggleText = toggleText;
      if (!unsavedChangesConfirmRef.value) {
        // If confirmation dialog is not available, proceed with the action
        return await onConfirm();
      }
      const confirmed = await unsavedChangesConfirmRef.value.open();
      unsavedDialog.title = 'Discard Changes?';
      unsavedDialog.message = 'You have unsaved changes to this time entry. If you close now, your edits will be lost.';
      unsavedDialog.confirmText = 'Discard Changes';
      unsavedDialog.toggleText = 'Keep Editing';
      if (confirmed) {
        return await onConfirm();
      }
      return proceedOnToggle;
    };
    const trackM365TimeEntry = entry => {
      // Only track M365 entries
      if (!entry.hours) {
        return;
      }

      // Calculate required properties
      const duration = entry.hours || 0;
      const value = entry.billingType?.id === 'billable' ? duration * (entry.rate?.amount || 0) : 0;
      props.tracking?.event?.('Clicked', 'Time Entry Created', {
        duration: duration,
        value: value
      });
    };
    const getCharge = async (forceRefresh = false) => {
      if (!editEntryState.matterDetail?.id) {
        editEntryState.fixedFeeList = [];
        return;
      }
      const matterId = editEntryState.matterDetail?.id;
      const billedState = editEntryState.form.billedState;
      if (!billedState || billedState === 'WIP') {
        editEntryState.fixedFeeList = await listChargesForTimeEntry({
          matterId
        }, forceRefresh);
        if (editEntryState.fixedFeeList?.length === 1 && !editEntryState.isInitialEditEntryLoad) {
          editEntryState.form.charge = editEntryState.fixedFeeList[0];
        }
      } else if (editEntryState.form.charge) {
        editEntryState.fixedFeeList = [editEntryState.form.charge];
      }
    };
    const closeModal = (reload, isNewEntry = null) => {
      console.log('[EditEntry] closeModal called, reload:', reload, 'isNewEntry:', isNewEntry, 'isModal:', props.isModal, 'isPanel:', props.isPanel);
      editEntryState.openUnsavedChangesDialog = false;

      // If this is a panel or modal, emit close event instead of navigation
      if (props.isPanel || props.isModal) {
        // Use passed isNewEntry if available, otherwise determine from current state
        const isCreateOperation = isNewEntry !== null ? isNewEntry : !editEntryState.entryId || editEntryState.duplicate;
        const emitData = {
          isNewEntry: isCreateOperation,
          externalEvent: combinedParams.value.externalEvent,
          saved: !!reload // Include saved flag based on reload parameter
        };
        console.log('[EditEntry] Emitting addOrEditEntry with data:', emitData);
        emit('close');
        emit('addOrEditEntry', emitData);
        return;
      }
      let willReload = !props.state.includes('time') && !props.state.includes('timeplanner') && !props.state.includes('reports.generic');
      if (reload) {
        willReload = true;
      }
      if (props.state.includes('time')) {
        emit('addOrEditEntry', {
          isNewEntry: combinedParams.value.isNewEntry,
          externalEvent: combinedParams.value.externalEvent
        });
        return;
      }
      props.state.go('^', {}, {
        reload: willReload
      });
    };
    const openUnsavedChangesDialog = () => {
      if (!somethingChanged.value) {
        // For modal/panel, emit close event; otherwise use closeModal
        if (props.isModal) {
          emit('close');
        } else {
          closeModal();
        }
        return;
      }
      if (!unsavedChangesConfirmRef.value) {
        // If confirmation dialog is not available, just close
        if (props.isModal) {
          emit('close');
        } else {
          closeModal();
        }
        return;
      }
      unsavedChangesConfirmRef.value.open().then(confirmed => {
        if (confirmed) {
          // Use the composable's handleClose to clear form state
          timeEntryToggle.handleClose(editEntryState, combinedParams.value, () => getFormState.value, emit);

          // For modal/panel, the composable already emits close;
          // For direct modal close, still need to call closeModal
          if (!props.isModal) {
            closeModal();
          }
        }
      });
    };
    const handleCloseClick = () => {
      if (somethingChanged.value) {
        openUnsavedChangesDialog();
      } else {
        // Use the composable's handleClose to clear form state
        timeEntryToggle.handleClose(editEntryState, combinedParams, () => getFormState.value, emit);

        // For modal/panel, the composable already emits close;
        // For direct modal close, still need to call closeModal
        if (!props.isModal) {
          closeModal();
        }
      }
    };

    /**
     * Panel → Modal transition handler
     * Saves current form state and emits expand event for parent component
     * The parent component (Time.vue) handles opening the modal with preserved data
     */
    const handleExpandClick = async () => {
      await timeEntryToggle.handleExpand(editEntryState, combinedParams, () => getFormState.value, emit);
    };

    /**
     * Modal → Panel transition handler
     * Saves current form state and emits minimize event for parent component
     * The parent component (Time.vue) handles opening the panel with preserved data
     */
    const handleMinimizeClick = async () => {
      await timeEntryToggle.handleMinimize(editEntryState, combinedParams, () => getFormState.value, emit);
    };
    const getAccountById = () => {
      if (!editEntryState.form?.account) {
        if (me.value.role === 'accountant') {
          return {
            id: undefined,
            name: 'Pick a Timekeeper'
          };
        }
        return me.value;
      }
      const account = editEntryState.accounts.find(account => account.id === editEntryState.form?.account?.id);
      return account;
    };
    const deleteDialogOpen = () => {
      deleteConfirmRef.value.open().then(confirmed => {
        if (confirmed) {
          deleteEntry();
        }
      });
    };
    const deleteEntry = async () => {
      await entryStore.deleteEntry(editEntryState.form.id);

      // Emit the delete event to parent - let the modal handle route navigation
      emit('addOrEditEntry', {
        deleted: true,
        saved: false
      });

      // For modal/panel, just emit the event and let the parent handle everything
      if (props.isPanel || props.isModal) {
        return;
      }

      // For non-modal usage, handle navigation directly
      const currentRoute = props.state?.current?.name;
      const routesRequiringReload = ['billing.invoice.builder.entry2', 'billing.invoice.matter.entry2', 'reports.generic.entry2'];
      if (routesRequiringReload.includes(currentRoute)) {
        // Go back to parent route with reload to refresh the data
        props.state.go('^', {}, {
          reload: true
        });
      } else {
        closeModal();
      }
      timeEntryToggle.initializePersistence(editEntryState, combinedParams, setFormState);
    };
    const accountChanged = async event => {
      const previousAccount = editEntryState.form.account;
      editEntryState.form.account = event;
      const isExistingEntry = !!editEntryState.form.id && !editEntryState.duplicate;
      const hadMatterBefore = !!editEntryState.matterDetail;
      if (isExistingEntry && hadMatterBefore) {
        // For existing entries with a matter, preserve matter but update rates for new user
        // Set flag to prevent matter change from overriding user change
        editEntryState.isUserChanging = true;

        // Clear rate so it gets recalculated for the new user
        editEntryState.form.rate = null;

        // Adjust rates with isUserChange=true to force rate selection for new user
        await adjustRateToSelection(false, true);

        // Clear flag after rate adjustment is complete
        editEntryState.isUserChanging = false;
      } else {
        // For new entries, always clear client and matter when timekeeper changes
        // This prevents invalid combinations of timekeeper + matter + rates
        editEntryState.form.client = null;
        editEntryState.form.matter = null;
        editEntryState.matterDetail = null;
        editEntryState.rateList = [];
        editEntryState.form.rate = null;
      }
    };
    const billingTypeChanged = async event => {
      editEntryState.form.billingType = event.billingType;
      if (event.billingType.id === 'billable') {
        await adjustRateToSelection(false, true);
      }
      editEntryState.isInitialEditEntryLoad = false;
      if (event.billingType?.id === 'fixedFee') {
        await getCharge();
      } else {
        editEntryState.form.charge = undefined;
        editEntryState.fixedFeeList = [];
      }
    };
    const deriveFlagsAndApplyBillingType = (state, matterHasChanged) => {
      const {
        type
      } = state.matterDetail?.billing || {};
      const isFixedFee = state.matterDetail?.fixed || type === 'fixed';
      const isNonBillable = ['contingency', 'internal', 'none'].includes(type);

      // When the matter changes, this isn't an initial load, or billingType was never set,
      // set billingType to match the matter's billing configuration
      const currentBillingType = state.form.billingType?.id || state.form.billingType;
      if (matterHasChanged || !state.isInitialEditEntryLoad || !currentBillingType) {
        let billingType;
        if (isFixedFee) {
          billingType = {
            id: 'fixedFee',
            label: 'Fixed Fee'
          };
        } else if (isNonBillable) {
          billingType = {
            id: 'nonBillable',
            label: 'Non-Billable'
          };
        } else {
          billingType = {
            id: 'billable',
            label: 'Billable'
          };
        }
        state.form.billingType = billingType;
      }
      return {
        type,
        isFixedFee,
        isNonBillable
      };
    };
    const matterChanged = async (forceRefresh = false, isMatterChange = true) => {
      const previousMatterId = editEntryState.matterDetail?.id || null;
      if (!editEntryState.form.matter?.id) {
        editEntryState.form.charge = undefined;
        editEntryState.form.billingType = undefined;
        editEntryState.fixedFeeList = [];
        editEntryState.isInitialEditEntryLoad = false;
        editEntryState.matterDetail = null;
        return;
      }
      if (editEntryState.matterLoading || editEntryState.formRestorationInProgress) {
        return;
      }

      // Check if matter detail is already loaded for the same matter ID
      if (editEntryState.matterDetail?.id === editEntryState.form.matter.id && !forceRefresh) {
        // Matter detail already loaded, no need to reload unless this is initial load or forced refresh
        if (!editEntryState.isInitialEditEntryLoad) {
          return;
        }
      }

      // If the selected matter changed, treat this as an explicit user change
      // and ensure defaults (like billingType) are recalculated for the new matter
      const selectedMatterId = editEntryState.form.matter.id;
      const matterHasChanged = previousMatterId && previousMatterId !== selectedMatterId;
      if (matterHasChanged) {
        editEntryState.isInitialEditEntryLoad = false;
        // Set flag to indicate user has changed matters during this editing session
        if (isMatterChange && editEntryState.originalEntry) {
          editEntryState.matterChangedDuringSession = true;
        }
      }
      editEntryState.matterLoading = true;
      editEntryState.entryBillingTypes = entryBillingTypes;
      try {
        // Store existing charge before potentially clearing it
        const existingCharge = editEntryState.form.charge;

        // Clear dependent fields when not on initial load OR when the matter has changed
        if (!editEntryState.isInitialEditEntryLoad || matterHasChanged) {
          editEntryState.fixedFeeList = [];
          editEntryState.form.charge = undefined;
        }
        editEntryState.matterDetail = await getMatterByIdForEntryDropdown(editEntryState.form.matter.id, forceRefresh);
        const {
          type,
          isFixedFee,
          isNonBillable
        } = deriveFlagsAndApplyBillingType(editEntryState, matterHasChanged);
        if (isFixedFee || editEntryState.form.billingType?.id === 'fixedFee' || editEntryState.form.billingType === 'fixedFee') {
          await getCharge();

          // Restore existing charge only when not on initial load and the matter
          // has not changed (e.g., panel ↔ modal persistence on same matter)
          if (existingCharge && !editEntryState.isInitialEditEntryLoad && !matterHasChanged) {
            const validCharge = editEntryState.fixedFeeList?.find(charge => charge.id === existingCharge.id);
            if (validCharge) {
              editEntryState.form.charge = validCharge;
            }
          }
        }
        if (isNonBillable) {
          editEntryState.entryBillingTypes = type === 'none' ? entryBillingTypes : entryBillingTypes.filter(b => b.id !== 'billable');
        } else {
          editEntryState.entryBillingTypes = entryBillingTypes;
        }

        // Skip rate adjustment if user is currently being changed to prevent override
        if (editEntryState.isUserChanging) {
          // Skip rate adjustment during user change to prevent conflicts
        } else {
          adjustRateToSelection(isMatterChange, false); // Explicitly pass isUserChange=false
        }
      } finally {
        editEntryState.matterLoading = false;
      }
    };
    const handleFormUpdate = updatedForm => {
      if (updatedForm.charge !== editEntryState.form.charge) {
        editEntryState.form.charge = updatedForm.charge;
        editEntryState.isInitialEditEntryLoad = false;
      }
      if (updatedForm.billingType && (updatedForm.billingType?.id || updatedForm.billingType) !== (editEntryState.form.billingType?.id || editEntryState.form.billingType)) {
        billingTypeChanged(updatedForm);
      }
    };
    const handleAddNewFixedFeeTemplate = async searchText => {
      try {
        // Check if we have a matter selected
        if (!editEntryState.form.matter?.id) {
          props.alerts?.error?.('Please select a matter before creating a fixed fee.');
          return;
        }

        // Open the CreateCharge dialog
        showCreateCharge.value = true;
        await nextTick();
        if (createChargeRef.value && createChargeRef.value.activate) {
          createChargeRef.value.activate(searchText);
        }
      } catch (error) {
        props.alerts?.error?.('Failed to open fixed fee creation dialog.');
      }
    };

    /**
     * Handle rate changes from dropdown.
     * Simple rule: For existing entries (with ID), preserve the edited flag state.
     * For new entries: compare against default to determine edited flag.
     */
    const handleRateChangeUpdate = updatedForm => {
      if (!updatedForm?.rate) return;

      // Check if this is an existing entry (has ID and not a duplicate)
      const isExistingEntry = !!editEntryState.form.id && !editEntryState.duplicate;
      // No comparisons needed - if it was edited before, keep it edited
      if (isExistingEntry) {
        // For existing entries, we need to check if the entry was EVER edited
        // This is stored in the original entry data when loaded
        const wasOriginallyEdited = editEntryState.originalEntry?.rate?.edited === true;
        if (wasOriginallyEdited) {
          updatedForm.rate.edited = true;
        } else {
          // Don't set edited flag for existing entries that never had it
          if (updatedForm.rate.edited) delete updatedForm.rate.edited;
        }
        editEntryState.form.rate = updatedForm.rate;
        return;
      }

      // For NEW ENTRIES ONLY: Compare against baseline to determine if rate was edited
      setDefaultRateBaseline(updatedForm.rate);
      const currentIdentity = buildRateIdentity(updatedForm.rate);
      const defaultIdentity = defaultRateSignature;
      const isChangingFromDefault = currentIdentity !== defaultIdentity;
      if (isChangingFromDefault) {
        updatedForm.rate.edited = true;
      } else {
        if (updatedForm.rate.edited) delete updatedForm.rate.edited;
      }
      editEntryState.form.rate = updatedForm.rate;
    };
    const handleCodeChange = data => {
      editEntryState.form.codes = data;
      // Note: Description handling is done by the CodePicker component itself
    };

    /**
     * Duplicates an existing time entry to create a new one with the same data
     *
     * IMPORTANT: Sets editEntryState.duplicate = true which affects session management
     * Duplicates are treated as NEW entries in the persistence system to prevent
     * them from accessing the original entry's saved state.
     *
     * @param {string} entryId - ID of the entry to duplicate
     */
    const duplicateEntry = async entryId => {
      // Check for unsaved changes before duplicating
      if (somethingChanged.value) {
        if (unsavedChangesConfirmRef.value) {
          const confirmed = await unsavedChangesConfirmRef.value.open();
          if (!confirmed) {
            return; // User chose to keep editing
          }
        }
      }
      editEntryState.loading = true;
      editEntryState.duplicate = false; // Reset duplicate flag before starting

      const duplicatedEntry = await entryStore.getEntry(entryId);
      const loadedEntry = entryInitStore.loadEntry(duplicatedEntry);

      // Create Date objects from the time strings
      const startDateTime = new Date(duplicatedEntry.startTime);
      const endDateTime = new Date(duplicatedEntry.endTime);

      // Create new Date objects for the current day
      const startTime = new Date();
      const endTime = new Date();

      // Set hours and minutes from the original entry
      startTime.setHours(startDateTime.getHours(), startDateTime.getMinutes());
      endTime.setHours(endDateTime.getHours(), endDateTime.getMinutes());
      const durationHours = (endTime - startTime) / 1000 / 60 / 60;
      loadedEntry.date = startTime;
      loadedEntry.hours = +durationHours;
      delete loadedEntry.id;
      const {
        id
      } = duplicatedEntry.account;
      const user = editEntryState.accounts.find(u => u.id === id);
      editEntryState.accounts = editEntryState.accounts.filter(u => u.role !== 'accountant');

      // If the entry's account is not in the list (e.g. deactivated user or accountant role),
      // add them back so the timekeeper dropdown displays correctly.
      if (!editEntryState.accounts.find(a => a.id === id)) {
        editEntryState.accounts.push(user || duplicatedEntry.account);
      }
      await processEntry(loadedEntry);

      // CRITICAL: Mark as duplicate AFTER processing
      // This flag affects session management in the persistence system
      // Duplicates get their own unique session key to prevent data contamination
      editEntryState.duplicate = true;
      editEntryState.isInitialEditEntryLoad = true;

      // Initialize billing types before calling matterChanged
      editEntryState.entryBillingTypes = entryBillingTypes;
      // For duplication, don't treat this as a matter change - preserve the original rate
      await matterChanged(false, false); // forceRefresh=false, isMatterChange=false
      setOriginalForm();
      editEntryState.loading = false;
    };
    const handleHoursCalculated = calculatedHours => {
      editEntryState.form.hours = calculatedHours;
      editEntryState.form.endTime = entryInitStore.updateEndTime(editEntryState.form, calculatedHours);
      // Update step based on calculated hours for consistency
      entryInitStore.updateStep(calculatedHours);
    };
    const handleExternalDuplicateRequest = event => {
      const params = event.detail;
      if (params && params.duplicateEntryId) {
        duplicateEntry(params.duplicateEntryId);
      }
    };
    const somethingChanged = computed(() => {
      // CRITICAL: During form restoration, always consider form as "changed" to keep save button enabled
      // This prevents save button from being disabled during panel ↔ modal transitions
      if (editEntryState.formRestorationInProgress) {
        return true;
      }

      // CRITICAL: For new entries (no originalEntry), check if form has meaningful data
      // This ensures the save button is enabled during panel ↔ modal transitions for new entries
      if (!editEntryState.originalEntry) {
        // For new entries, consider it "changed" if basic required fields are filled
        const form = editEntryState.form;
        return !!(form.account?.id || form.matter?.id || form.description?.trim() || form.hours);
      }

      // For existing entries, check if form differs from original
      try {
        const ignoreStartStop = !editEntryState.showStartStopTime;
        const current = getSimplifiedForm(editEntryState.form, ignoreStartStop);
        const original = getSimplifiedForm(editEntryState.originalEntry, ignoreStartStop);
        return JSON.stringify(current) !== JSON.stringify(original);
      } catch (error) {
        console.error('[EditEntry] Error in somethingChanged computation:', error);
        // On error, assume something changed to keep save button enabled
        return true;
      }
    });

    // Expose method for parent component to call
    const handleDuplicateRequest = entryId => {
      if (entryId) {
        duplicateEntry(entryId);
      }
    };
    const addNewClient = (typedClientName = '', method = '') => {
      showCreateClient.value = true;
      nextTick(() => {
        if (createClientRef.value && createClientRef.value.openDialog) {
          createClientRef.value.openDialog(typedClientName, method);
        }
      });
    };
    const addNewMatter = (typedMatterName = '', method = '') => {
      showCreateMatter.value = true;
      nextTick(() => {
        if (createMatterRef.value && createMatterRef.value.openDialog) {
          createMatterRef.value.openDialog(typedMatterName, method);
        }
      });
    };
    const handleClientCreated = newClient => {
      showCreateClient.value = false;
      if (newClient && clientMatterSearchRef.value) {
        editEntryState.form.client = newClient;
        addNewMatter();
      }
    };
    const handleMatterCreated = async newMatter => {
      showCreateMatter.value = false;
      if (newMatter && clientMatterSearchRef.value) {
        editEntryState.form.matter = newMatter;
        if (newMatter.client) {
          editEntryState.form.client = newMatter.client;
        }

        // Then refresh the matters list - this will clear any search that got set
        if (clientMatterSearchRef.value?.refreshMatters) {
          await clientMatterSearchRef.value.refreshMatters();
        }
        matterChanged(true, true); // forceRefresh=true, isMatterChange=true
      }
    };
    const handleClientClosed = () => {
      showCreateClient.value = false;
    };
    const handleMatterClosed = () => {
      showCreateMatter.value = false;
    };
    const handleChargeCreated = async newCharge => {
      await getCharge(true);
      // Find the charge using case-insensitive comparison
      const foundCharge = editEntryState.fixedFeeList.find(c => c.id.toLowerCase() === newCharge.id.toLowerCase());
      editEntryState.form.charge = foundCharge;
      showCreateCharge.value = false;
    };
    const handleChargeClosed = () => {
      showCreateCharge.value = false;
    };

    // Optimized form state management using Vue's built-in reactivity
    // This computed property efficiently tracks form state changes and provides
    // the complete form snapshot for persistence during panel ↔ modal transitions
    const getFormState = computed(() => {
      if (!editEntryState.form) {
        return null;
      }

      // Use toRaw to get non-reactive snapshot, then structuredClone for deep copy
      // This is more efficient than custom cloning and leverages browser optimizations
      const formSnapshot = structuredClone(toRaw(editEntryState.form));
      return {
        form: formSnapshot,
        // CRITICAL: Save the original entry baseline to preserve change detection across panel ↔ modal transitions
        originalEntry: editEntryState.originalEntry ? structuredClone(toRaw(editEntryState.originalEntry)) : null,
        uiState: {
          showStartStopTime: editEntryState.showStartStopTime,
          adjustments: editEntryState.adjustments,
          isInitialEditEntryLoad: editEntryState.isInitialEditEntryLoad,
          okToClearDescription: editEntryState.okToClearDescription || false,
          duplicate: editEntryState.duplicate || false
        },
        componentState: {
          // Use toRaw + slice for efficient array copying - capture ALL component state
          entryBillingTypes: toRaw(editEntryState.entryBillingTypes || []).slice(),
          fixedFeeList: toRaw(editEntryState.fixedFeeList || []).slice(),
          rateList: toRaw(editEntryState.rateList || []).slice(),
          // Add other important component state that might affect form behavior
          matterDetail: editEntryState.matterDetail ? structuredClone(toRaw(editEntryState.matterDetail)) : null,
          rateGroups: toRaw(editEntryState.rateGroups || []).slice(),
          activityCodes: toRaw(editEntryState.activityCodes || []).slice(),
          taskCodes: toRaw(editEntryState.taskCodes || []).slice(),
          // UI-related state that affects form behavior
          showRateAdjustment: editEntryState.showRateAdjustment || false,
          entryId: editEntryState.entryId || null
        },
        timestamp: Date.now()
      };
    });

    /**
     * SIMPLE form state restoration
     * Just restore the form data - no complex flags or timing
     */
    const setFormState = async savedState => {
      if (!savedState || !editEntryState.form) {
        return false;
      }
      try {
        // Handle different formats of form state (backwards compatibility)
        const {
          form: formData = savedState,
          originalEntry = null,
          uiState = {},
          componentState = {}
        } = savedState;

        // Simple: assign all form properties to trigger Vue reactivity
        if (formData) {
          for (const [key, value] of Object.entries(formData)) {
            editEntryState.form[key] = value;
          }
        }

        // CRITICAL: Restore originalEntry to maintain unsaved changes detection during panel ↔ modal transitions
        // This ensures the "unsaved changes" dialog works correctly after switching between panel and modal
        if (originalEntry !== null) {
          editEntryState.originalEntry = originalEntry;
        }

        // Restore UI state
        if (uiState.showStartStopTime !== undefined) {
          editEntryState.showStartStopTime = uiState.showStartStopTime;
        }

        // CRITICAL: Restore duplicate flag to maintain "Duplicate Time Entry" title during panel ↔ modal transitions
        if (uiState.duplicate !== undefined) {
          editEntryState.duplicate = uiState.duplicate;
        }

        // Restore other UI state for completeness
        if (uiState.adjustments !== undefined) {
          editEntryState.adjustments = uiState.adjustments;
        }
        if (uiState.isInitialEditEntryLoad !== undefined) {
          editEntryState.isInitialEditEntryLoad = uiState.isInitialEditEntryLoad;
        }
        if (uiState.okToClearDescription !== undefined) {
          editEntryState.okToClearDescription = uiState.okToClearDescription;
        }

        // Restore component state critical for billing functionality
        // This ensures billing types and fixed fee lists persist during panel ↔ modal transitions
        if (componentState.entryBillingTypes) {
          editEntryState.entryBillingTypes = componentState.entryBillingTypes;
        }
        if (componentState.fixedFeeList) {
          editEntryState.fixedFeeList = componentState.fixedFeeList;
        }

        // Force ClientMatterSearch component to re-render with restored client/matter data
        // This is crucial for duplicate entries when toggling between panel ↔ modal views
        if (formData.client?.id || formData.matter?.id) {
          clientMatterSearchKey.value += 1;
        }
        return true;
      } catch (error) {
        console.error('❌ setFormState: Failed to restore form state:', error);
        return false;
      }
    };

    // Expose methods so parent components can call them
    __expose({
      handleCloseClick,
      handleDuplicateRequest,
      confirmDiscardChanges,
      getFormState: () => getFormState.value,
      setFormState
    });
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['bg-white w-full h-full edit-entry-component', {
          'p-0': __props.isModal,
          'p-1 space-y-4': !__props.isModal
        }]),
        ref_key: "rootElementRef",
        ref: rootElementRef
      }, [editEntryState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Time Entry',
        class: _normalizeClass(__props.isModal ? 'my-4 ' : 'mt-32')
      }, null, 8, ["class"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(MainHeader, {
        isBillingPageTitle: true,
        content: headerContent.value
      }, null, 8, ["content"]), _createElementVNode("div", _hoisted_3, [__props.showExpandButton && __props.isTimeEntryPage ? (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 0,
        icon: "mdi-arrow-expand",
        variant: "text",
        size: "small",
        class: "flex-shrink-0",
        title: "Expand to full modal",
        "aria-label": "Expand to full modal",
        "data-cy": "expand-modal-button",
        onClick: _cache[0] || (_cache[0] = $event => handleExpandClick())
      })) : _createCommentVNode("", true), __props.showMinimizeButton && __props.isTimeEntryPage ? (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 1,
        icon: "mdi-arrow-collapse",
        variant: "text",
        size: "small",
        class: "flex-shrink-0",
        title: "Minimize to side panel",
        "aria-label": "Minimize to side panel",
        "data-cy": "minimize-modal-button",
        onClick: _cache[1] || (_cache[1] = $event => handleMinimizeClick())
      })) : _createCommentVNode("", true), _unref(features)?.enableTimeEntryShortcuts ? (_openBlock(), _createBlock(LlTooltip, {
        key: 2,
        text: _unref(getShortcutTooltip)('cancel', 'Close time entry modal'),
        location: "left"
      }, {
        activator: _withCtx(({
          props: tooltipProps
        }) => [_createVNode(LlSecondaryButton, _mergeProps(tooltipProps, {
          icon: "mdi-close",
          variant: "text",
          size: "small",
          class: "flex-shrink-0",
          "aria-label": "Close time entry",
          "data-cy": "close-icon",
          onClick: _cache[2] || (_cache[2] = $event => handleCloseClick())
        }), null, 16)]),
        _: 1
      }, 8, ["text"])) : (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 3,
        icon: "mdi-close",
        variant: "text",
        size: "small",
        class: "flex-shrink-0",
        "aria-label": "Close time entry",
        "data-cy": "close-icon",
        onClick: _cache[3] || (_cache[3] = $event => handleCloseClick())
      }))])]), _createVNode(LlConfirmationDialog, {
        ref_key: "deleteConfirmRef",
        ref: deleteConfirmRef,
        title: "Delete Time Entry",
        message: "This will permanently delete the time entry. Is that ok?",
        "toggle-text": "Cancel",
        "confirm-text": "OK",
        "show-warning-icon": true
      }, null, 512), _createVNode(LlConfirmationDialog, {
        ref_key: "unsavedChangesConfirmRef",
        ref: unsavedChangesConfirmRef,
        title: unsavedDialog.title,
        message: unsavedDialog.message,
        "toggle-text": unsavedDialog.toggleText,
        "confirm-text": unsavedDialog.confirmText,
        "show-warning-icon": true
      }, null, 8, ["title", "message", "toggle-text", "confirm-text"]), shouldShowBilledAlert.value ? (_openBlock(), _createBlock(AlertBar, {
        key: 0,
        content: getBilledAlertMessage(),
        "data-cy": "billed-alert-message"
      }, null, 8, ["content"])) : _createCommentVNode("", true), _createVNode(_component_v_container, {
        id: "scroll-target",
        class: _normalizeClass(containerClasses.value),
        "data-cy": "edit-entry-container"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", {
          class: _normalizeClass(__props.isModal ? 'flex flex-row gap-4 w-full' : 'flex-row justify-between w-full')
        }, [_createElementVNode("div", {
          class: _normalizeClass(__props.isModal ? 'flex-1 ' : 'w-full ')
        }, [_createVNode(LlDatePicker, {
          modelValue: editEntryState.form.date,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => editEntryState.form.date = $event),
          label: "Date",
          showButton: false,
          isRequired: true,
          autofocus: shouldAutofocus.value,
          "data-cy": "date-picker",
          tabindex: "0"
        }, null, 8, ["modelValue", "autofocus"])], 2), _createElementVNode("div", {
          class: _normalizeClass(__props.isModal ? 'flex-1' : '')
        }, [_createVNode(TimekeeperPicker, {
          disabled: isTimekeeperPickerDisabled.value,
          form: editEntryState.form,
          rules: [v => !!v?.id || 'Timekeeper is required.'],
          hideDetails: false,
          required: true,
          "onUpdate:form": _cache[5] || (_cache[5] = updatedForm => accountChanged(updatedForm.account)),
          tabindex: "0"
        }, null, 8, ["disabled", "form", "rules"])], 2)], 2), _createElementVNode("div", null, [(_openBlock(), _createBlock(ClientMatterSearch, {
          key: clientMatterSearchKey.value,
          ref_key: "clientMatterSearchRef",
          ref: clientMatterSearchRef,
          emitOnAnyChange: true,
          cm: editEntryState.form,
          "query-filter": cmQueryFilter.value,
          horizontal: !__props.isModal,
          clientRules: [v => !!v?.id || 'A client is required.'],
          matterRules: [v => !!v?.id || 'A matter is required.'],
          hideDetails: false,
          required: true,
          onMatterChange: _cache[6] || (_cache[6] = $event => matterChanged(true, true)),
          onAddNewClient: addNewClient,
          onAddNewMatter: addNewMatter,
          showAddClientMatter: _unref(permissions).matters?.create,
          "data-cy": "edit-entry-client-matter-search",
          tabindex: "0"
        }, null, 8, ["cm", "query-filter", "horizontal", "clientRules", "matterRules", "showAddClientMatter"]))]), _withDirectives(_createElementVNode("div", null, [showCodePickerSkeleton.value ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 0,
          type: "heading"
        })) : showCodePicker.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(CodePicker, {
          horizontal: !__props.isModal,
          form: editEntryState.form,
          okToClearDescription: editEntryState.okToClearDescription,
          activityRules: [v => {
            const requiredCodes = editEntryState.matterDetail?.client?.codes?.required || {};
            return !requiredCodes.activity || !!v?.id || 'Activity code is required.';
          }],
          taskRules: [v => {
            const requiredCodes = editEntryState.matterDetail?.client?.codes?.required || {};
            return !requiredCodes.task || !!v?.id || 'Task code is required.';
          }],
          activityRequired: isActivityRequired.value,
          taskRequired: isTaskRequired.value,
          hideDetails: false,
          onCodeChange: handleCodeChange,
          "data-cy": "edit-entry-code-picker"
        }, null, 8, ["horizontal", "form", "okToClearDescription", "activityRules", "taskRules", "activityRequired", "taskRequired"])])) : _createCommentVNode("", true)], 512), [[_vShow, showCodePicker.value || showCodePickerSkeleton.value]]), _createElementVNode("div", null, [(_openBlock(), _createBlock(DescriptionInput, {
          key: descriptionInputKey.value,
          form: editEntryState.form,
          snippetService: __props.snippetService,
          editEntryState: editEntryState,
          "enable-block-billing": true,
          hideDetails: false,
          required: true,
          rules: [v => !!v && v.trim() !== '' || 'A description is required.'],
          onHoursCalculated: handleHoursCalculated,
          onDescriptionEdited: _cache[7] || (_cache[7] = $event => editEntryState.okToClearDescription = false),
          "data-cy": "edit-entry-description-input",
          tabindex: "0"
        }, null, 8, ["form", "snippetService", "editEntryState", "rules"]))]), _createVNode(InternalNotesToggle, {
          modelValue: editEntryState.form.note,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => editEntryState.form.note = $event),
          disabled: editEntryState.form.billed
        }, null, 8, ["modelValue", "disabled"]), _createElementVNode("div", null, [showBillableTypePickerSkeleton.value ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 0,
          type: "heading"
        })) : showBillableTypePicker.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [__props.isModal ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
          class: _normalizeClass(['flex items-center', isFixedFeeSelected.value ? 'flex-col gap-2' : 'gap-4'])
        }, [_createElementVNode("div", _hoisted_7, [_createVNode(BillableTypePicker, {
          horizontal: !__props.isModal,
          form: editEntryState.form,
          fixedFeeList: editEntryState.fixedFeeList,
          entryBillingTypes: editEntryState.entryBillingTypes,
          hideDetails: false,
          showAddFixedFeeModel: _unref(permissions).charges?.create,
          "onUpdate:form": handleFormUpdate,
          onAddNewFixedFeeTemplate: handleAddNewFixedFeeTemplate
        }, null, 8, ["horizontal", "form", "fixedFeeList", "entryBillingTypes", "showAddFixedFeeModel"])]), _createElementVNode("div", _hoisted_8, [_unref(customFlagLabel) ? (_openBlock(), _createBlock(LlCheckbox, {
          key: 0,
          modelValue: editEntryState.form.customFlag,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => editEntryState.form.customFlag = $event),
          label: _unref(customFlagLabel)
        }, null, 8, ["modelValue", "label"])) : _createCommentVNode("", true)])], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(BillableTypePicker, {
          horizontal: true,
          form: editEntryState.form,
          fixedFeeList: editEntryState.fixedFeeList,
          entryBillingTypes: editEntryState.entryBillingTypes,
          hideDetails: false,
          showAddFixedFeeModel: _unref(permissions).charges?.create,
          "onUpdate:form": handleFormUpdate,
          onAddNewFixedFeeTemplate: handleAddNewFixedFeeTemplate
        }, null, 8, ["form", "fixedFeeList", "entryBillingTypes", "showAddFixedFeeModel"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_unref(customFlagLabel) ? (_openBlock(), _createBlock(LlCheckbox, {
          key: 0,
          modelValue: editEntryState.form.customFlag,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => editEntryState.form.customFlag = $event),
          label: _unref(customFlagLabel)
        }, null, 8, ["modelValue", "label"])) : _createCommentVNode("", true)]), _createVNode(LlDoubleSwitch, {
          modelValue: editEntryState.showStartStopTime,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => editEntryState.showStartStopTime = $event),
          "left-label": "Hours",
          "right-label": "Start/Stop"
        }, null, 8, ["modelValue"])])]))])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(StartEndTime, {
          form: editEntryState.form,
          entryEditService: __props.entryEditService,
          editEntryState: editEntryState,
          adjustments: editEntryState.adjustments,
          showStartStopTime: editEntryState.showStartStopTime,
          hourHideDetails: false,
          hourRequired: true,
          isModal: __props.isModal,
          "onUpdate:showStartStopTime": _cache[12] || (_cache[12] = $event => editEntryState.showStartStopTime = $event)
        }, null, 8, ["form", "entryEditService", "editEntryState", "adjustments", "showStartStopTime", "isModal"])]), showRateAdjustment.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(RateAdjustOptions, {
          isPanel: true,
          form: editEntryState.form,
          rateList: editEntryState.rateList,
          rateRules: [v => !v || v >= 0 || 'Amount cannot be negative'],
          hideDetails: false,
          "onUpdate:form": handleRateChangeUpdate,
          onAdjustRateToSelection: adjustRateToSelection,
          "data-cy": "edit-entry-rate-adjust-options"
        }, null, 8, ["form", "rateList", "rateRules"])])) : _createCommentVNode("", true), !__props.isModal ? (_openBlock(), _createElementBlock("div", _hoisted_13)) : _createCommentVNode("", true)]), _createVNode(EntryActions, {
          isModal: __props.isModal,
          editEntryState: editEntryState,
          formValid: formValid.value,
          entryChanged: somethingChanged.value,
          loading: isLoading.value,
          state: __props.state,
          isTimerConversion: editEntryState.isTimerConversion,
          hideDuplicateButton: __props.hideDuplicateButton,
          tracking: __props.tracking,
          onCreateEntry: createEntry,
          onClose: handleCloseClick,
          onDuplicateEntry: duplicateEntry,
          onDeleteDialogOpen: deleteDialogOpen
        }, null, 8, ["isModal", "editEntryState", "formValid", "entryChanged", "loading", "state", "isTimerConversion", "hideDuplicateButton", "tracking"])]),
        _: 1
      }, 8, ["class"])])), showCreateClient.value ? (_openBlock(), _createBlock(CreateClient, {
        key: 2,
        ref_key: "createClientRef",
        ref: createClientRef,
        state: __props.state,
        stateParams: _unref(stateParams),
        clientMatterManager: __props.angularClientMatterManager,
        onClientCreated: handleClientCreated,
        onClose: handleClientClosed,
        isfromVue: true
      }, null, 8, ["state", "stateParams", "clientMatterManager"])) : _createCommentVNode("", true), showCreateMatter.value ? (_openBlock(), _createBlock(CreateMatter, {
        key: 3,
        ref_key: "createMatterRef",
        ref: createMatterRef,
        state: __props.state,
        stateParams: _unref(stateParams),
        clientId: editEntryState.form.client?.id,
        onMatterCreated: handleMatterCreated,
        onClose: handleMatterClosed
      }, null, 8, ["state", "stateParams", "clientId"])) : _createCommentVNode("", true), showCreateCharge.value ? (_openBlock(), _createBlock(CreateChargeModal, {
        key: 4,
        ref_key: "createChargeRef",
        ref: createChargeRef,
        state: __props.state,
        isfromVue: true,
        stateParams: createChargeStateParams.value,
        tracking: __props.tracking,
        entryPoint: "entry_page",
        onFixedFeeCreated: handleChargeCreated,
        onClose: handleChargeClosed
      }, null, 8, ["state", "stateParams", "tracking"])) : _createCommentVNode("", true)], 2);
    };
  }
};